import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image"

class QualidadeMundial extends Component {
    render() {
        return(
            <div className="row" style={{margin: '0', padding: '0', width: '100%', backgroundColor: "#D3D3D3"}}>
                <div className="col-sm-6">
                    <div className="container" style={{paddingTop: '15%'}}>
                        <h2 style={{textAlign: 'center'}}>Qualidade Mundial</h2>
                        <ul style={{textAlign: 'justify', padding: '0 15% 0 15%'}}>
                           <li>Garantia de fábrica;</li>
                           <li>Cabos altamente flexíveis;</li>
                           <li>Todos os produtos são testados e aprovados;</li>
                           <li>Certificados internacionais de qualidade;</li>
                           <li>Investimento em desenvolvimento e tecnologia.</li>
                        </ul>
                    </div>
                </div>
                <div className="col-sm-6" style={{margin: '0', padding: '0'}}>
                    <GatsbyImage image={this.props.data.contentfulAsset.gatsbyImageData} alt="Imagem da Ibérica" />
                </div>
            </div>
        )
    }
 }

const QualidadeMundialQuery = () => (
    <StaticQuery
      query={graphql`
      query QualidadeMundialQuery {
        contentfulAsset(title: {eq: "qualidade-iberica-placeholder"}) {
            gatsbyImageData(quality: 100, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
        }
    }
    `}
      render={(data) => (
        <QualidadeMundial data={data} />
      )}
    />
  )

export default QualidadeMundialQuery